import { Meta } from "_common/_utils/Meta";
import React from "react";
import { useTranslation } from "react-i18next";
import sharedConfig from "_configs/sharedConfig";
import { useLocation } from "react-router-dom";

export default function CommunitiesMeta() {
    const { t } = useTranslation();
    const location = useLocation();
    return (
        <div>
            <Meta
                title={t("communitiesPage.meta.title")}
                description={t("communitiesPage.meta.description")}
                url={sharedConfig.appUrl + "/" + location.pathname}
            />
        </div>
    );
}
